// eslint-disable-next-line no-restricted-imports -- factory called at render time by useTranslation-aware consumers
import { t } from 'i18n/utils'

export const EMAIL_VALIDATION_MODE_SOFT = 'soft'
export const EMAIL_VALIDATION_MODE_HARD = 'hard'
export const getEmailValidationModes = () => [
  { label: t('emailValidation.hardReject'), value: EMAIL_VALIDATION_MODE_HARD },
  { label: t('emailValidation.softReject'), value: EMAIL_VALIDATION_MODE_SOFT }
]
export const SOFT_EMAIL_VALIDATION_DEBOUNCE_TIME = 2000
export const EMAIL_VALIDATION_API_URL = '/api/internal/email_address_external_verification?email='
